export default {
  GOOGLE_CALENDAR: {
    HEADER: 'Google Calendar',
    CONNECT: {
      TITLE: 'Conectá tu Google Calendar',
      DESCRIPTION: 'Visualizá tus eventos, compartí disponibilidad con el equipo y creá citas directamente desde las conversaciones.',
      BUTTON: 'Conectar cuenta de Google',
      CONNECTING: 'Conectando...',
      MODAL: {
        TITLE: 'Conectar Google Calendar',
        DESCRIPTION: 'Se solicitarán los siguientes permisos en tu cuenta de Google:',
        PERMISSIONS: [
          'Leer tus eventos de calendario',
          'Crear y editar eventos en tu nombre',
          'Crear y gestionar tus calendarios',
          'Ver tu disponibilidad (libre/ocupado)',
        ],
        CONFIRM: 'Conectar con Google',
        CANCEL: 'Cancelar',
      },
    },
    DISCONNECT: {
      BUTTON: 'Desconectar',
      CONFIRM: '¿Estás seguro de que querés desconectar tu Google Calendar?',
    },
    RECONNECT: {
      BUTTON: 'Reconectar',
    },
    CONNECTED_AS: 'Conectado como',
    EVENTS: {
      TITLE: 'Mi Calendario',
      EMPTY: 'No hay eventos para este período',
      NEW_EVENT: 'Nuevo Evento',
      ALL_DAY: 'Todo el día',
    },
    CALENDAR: {
      WEEK: 'Semana',
      MONTH: 'Mes',
      AGENDA: 'Agenda',
    },
    AGENDA: {
      TITLE: 'Próximos eventos',
      EMPTY: 'No hay eventos próximos',
      TODAY: 'Hoy',
      TOMORROW: 'Mañana',
    },
    CALENDARS: {
      TITLE: 'Mis calendarios',
      SUBSCRIBED: 'suscrito',
      SUBSCRIBE_BUTTON: 'Agregar otro calendario',
      SUBSCRIBE_PLACEHOLDER: 'email@ejemplo.com o ID del calendario',
      SUBSCRIBE_ADD: 'Agregar',
      SUBSCRIBE_MODAL_TITLE: 'Agregar otro calendario',
      SUBSCRIBE_MODAL_SUBTITLE: 'Ingresá el email o el ID del calendario de Google que querés ver. Debe estar compartido con tu cuenta.',
      MODE_CREATE: 'Crear nuevo',
      MODE_SUBSCRIBE: 'Suscribir existente',
      CREATE_HINT: 'Crea un calendario secundario NUEVO en tu cuenta de Google (como "Crear calendario nuevo" de Google).',
      CREATE_PLACEHOLDER: 'Nombre del calendario (p. ej. Consultorio Norte)',
      CREATE_ADD: 'Crear',
      ADD_ERROR: 'No se pudo agregar el calendario. Es posible que debas reconectar tu Google Calendar para habilitar esta función.',
      FIELD_NAME: 'Nombre',
      FIELD_DESCRIPTION: 'Descripción',
      FIELD_DESCRIPTION_PLACEHOLDER: 'Descripción del calendario (opcional)',
      FIELD_TIMEZONE: 'Zona horaria',
      FIELD_TIMEZONE_DEFAULT: 'Predeterminada de la cuenta',
      FIELD_COLOR: 'Color',
      EDIT_MODAL_TITLE: 'Editar calendario',
      EDIT_HINT: 'Modificá el nombre, la descripción, la zona horaria y el color del calendario.',
      SAVE: 'Guardar',
    },
    AVAILABILITY: {
      TITLE: 'Disponibilidad del equipo',
      BUSY: 'Ocupado',
      FREE: 'Libre',
      NOT_CONNECTED: 'Sin calendario',
    },
    CREATE_EVENT: {
      TITLE: 'Crear Evento',
      TYPE: {
        EVENT: 'Evento',
        TASK: 'Tarea',
      },
      FIELDS: {
        CALENDAR: 'Calendario',
        CALENDAR_PRIMARY: 'Principal',
        SUMMARY: 'Título',
        SUMMARY_PLACEHOLDER: 'Título del evento',
        TASK_PLACEHOLDER: 'Título de la tarea',
        ALL_DAY: 'Todo el día',
        START: 'Inicio',
        END: 'Fin',
        DUE_DATE: 'Fecha de vencimiento',
        LOCATION: 'Ubicación',
        LOCATION_PLACEHOLDER: 'Agregar ubicación',
        DESCRIPTION: 'Descripción',
        DESCRIPTION_PLACEHOLDER: 'Descripción del evento (opcional)',
        NOTES: 'Notas',
        NOTES_PLACEHOLDER: 'Agregar notas (opcional)',
        ATTENDEES: 'Invitados',
        ATTENDEES_PLACEHOLDER: 'Escribí un email y presioná Enter',
      },
      SUBMIT: 'Crear Evento',
      SUBMIT_TASK: 'Crear Tarea',
      CANCEL: 'Cancelar',
      SUCCESS: 'Evento creado exitosamente',
      SUCCESS_TASK: 'Tarea creada exitosamente',
      ERROR: 'No se pudo crear. Intentá de nuevo.',
    },
    EDIT_EVENT: {
      TITLE: 'Editar Evento',
      SUBMIT: 'Guardar cambios',
      SUCCESS: 'Evento actualizado exitosamente',
      ERROR: 'No se pudo actualizar el evento. Intentá de nuevo.',
    },
    CREATE_FROM_CONVERSATION: 'Crear evento de calendario',
    SHARE_AGENDA: {
      TITLE: 'Enviar mi agenda',
      DESCRIPTION: 'Elegí el período y a quién enviarle la agenda.',
      PERIOD: 'Período',
      TODAY: 'Hoy',
      DAYS_3: '3 días',
      DAYS_7: '7 días',
      INBOX: 'Canal de envío',
      INBOX_PLACEHOLDER: 'Seleccioná un canal',
      CONTACTS: 'Contactos',
      CONTACTS_PLACEHOLDER: 'Buscar contacto...',
      PREVIEW: 'Vista previa del mensaje',
      CANCEL: 'Cancelar',
      SEND: 'Enviar',
      SUCCESS: 'Agenda enviada exitosamente',
      ERROR: 'No se pudo enviar la agenda. Intentá de nuevo.',
    },
    API: {
      CONNECT_ERROR: 'No se pudo conectar a Google Calendar',
      DISCONNECT_SUCCESS: 'Google Calendar desconectado',
      DISCONNECT_ERROR: 'No se pudo desconectar Google Calendar',
      FETCH_ERROR: 'Error al cargar los eventos del calendario',
    },
  },
};
